import { ChangeDetectionStrategy, Component, Inject } from "@angular/core";
import { BadgeAssignment } from "@webapp/badges/models/badges.models";
import { UI_MODAL_DATA } from "@webapp/ui/modal/modal.models";

export interface ConfirmBadgeDeleteModalData {
  badgeAssignments: BadgeAssignment[];
}

@Component({
  selector: "confirm-badge-delete",
  templateUrl: "confirm-badge-delete.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmBadgeDeleteComponent implements ConfirmBadgeDeleteModalData {
  public badgeAssignments: BadgeAssignment[];

  constructor(@Inject(UI_MODAL_DATA) modalData: ConfirmBadgeDeleteModalData) {
    Object.assign(this, modalData);
  }
}
